const WORK_CLOCK_SHIFT_KEY = 'locshark_work_clock_shift';

export const saveWorkClockShiftSelection = ({ deviceId, deviceName, operatorName }) => {
  if (!deviceId) {
    return;
  }
  sessionStorage.setItem(WORK_CLOCK_SHIFT_KEY, JSON.stringify({
    deviceId,
    deviceName: deviceName || '',
    operatorName: operatorName || '',
  }));
};

export const loadWorkClockShiftSelection = () => {
  try {
    const raw = sessionStorage.getItem(WORK_CLOCK_SHIFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearWorkClockShiftSelection = () => {
  sessionStorage.removeItem(WORK_CLOCK_SHIFT_KEY);
};
